import {
    ApplicationConfig,
    ErrorHandler,
    mergeApplicationConfig,
} from '@angular/core';
import {
    provideClientHydration,
    withNoHttpTransferCache,
} from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { commonConfig } from './app.config.common';
import { environment } from './environments/environment';
import { ChunkLoadErrorHandler } from './services/errors/chunk-load-error.handler';
import {
    complex_links,
    request_hotel_motor,
    organization_name,
    SCROLL_OFFSET_TOKEN,
} from 'ctt-babylon';

export const appConfig: ApplicationConfig = mergeApplicationConfig(
    commonConfig,
    {
        providers: [
            // Sin transfer cache: la config de /data ya la cachea el navegador y la
            // página se pide por POST con datos del usuario, así que solo engordaría el HTML
            provideClientHydration(withNoHttpTransferCache()),
            provideAnimations(),
            { provide: ErrorHandler, useClass: ChunkLoadErrorHandler },
            {
                provide: complex_links,
                useValue: environment.menuComplexLinks,
            },
            {
                provide: organization_name,
                useValue: environment.organizationName,
            },
            {
                provide: SCROLL_OFFSET_TOKEN,
                useValue: -160, // Ajusta este valor según la altura de tu header
            },
            {
                provide: request_hotel_motor,
                useValue: environment.hotelRequestMotor,
            },
        ],
    }
);
